export default __webpack_public_path__ + "static/media/image-content-1.9dd39f72.jpg";